import { AdminDataInt, AdminResponseInt } from '@app/interfaces/admin.interface';
import { Admin } from '@app/enums';
import { normalizeNumberOfDecimals } from '@app/utils/functions/decimals';
export class AdminMapper {
  optionsAdmin: string[] = ['LOCALES', 'portPinpad'];

  mapDTOModel(data: AdminResponseInt): AdminDataInt {
    const admin: AdminDataInt = {
      bagTag: true,
      DOCV: true,
      HANDLE_OVERWEIGHT_BAG: false,
      noPassportScanner: false,
      outOfService: false,
      Payment: true,
      scale: true,
      SHOW_OVERBOOKING_VOLUNTEER_OFFER: false,
      SHOW_PREMIERE_OFFER: false,
      SHOW_SEAT_SELECT_PREMIERE_OFFER: false,
      TSA: false,
      WAIT_FOR_AGENT: false,
      AM_PLUS_UPSELL: false,
      Payment_And_Weighing_Test: false,
      INTERNATIONALROUTES: true,
      KIOSK_VERTICAL_SCREEN: true,
      USA_REQUIREMENTS: false,
      showIrops: false,
      showUSPerson: true,
      showSeatMap: true,
      iropReaccommed: false,
    };
    admin.maletas25KG = data.maletas25KG;

    for (const adminElement of data?.collection ?? []) {
      if (!this.optionsAdmin.includes(adminElement.name)) {
        if (Object.keys(admin).includes(adminElement.name)) {
          if (adminElement.value === '0' || adminElement.value === '') {
            adminElement.value = 'false';
          }
          admin[adminElement.name] = this.determinateValue(adminElement.value);
        } else if (adminElement.name === Admin.DEFAULT_LANGUAGE) {
          adminElement.value ??= 'es-MX';
          admin[adminElement.name] = adminElement.value;
        } else if (typeof this.determinateValue(adminElement.value) !== 'boolean') {
          admin[adminElement.name] = this.determinateValue(adminElement.value);
        }
      } else {
        admin[adminElement.name] = adminElement.value.split('~');
      }
    }

    if (!Object.prototype.hasOwnProperty.call(admin, Admin.DEFAULT_LANGUAGE)) {
      admin[Admin.DEFAULT_LANGUAGE] = 'es-MX';
    }

    // CI-21979: cantidad de decimales (CMS). Se lee el valor crudo del profile y
    // se normaliza (0/1/2 o undefined; sin default). Se hace fuera del loop
    // genérico para no corromper el caso "0" (que el loop convertiría a 'false').
    const rawNumberOfDecimals = data?.collection?.find(
      (item) => item.name === Admin.NUMBER_OF_DECIMALS_BE
    )?.value;
    admin.numberOfDecimalsBE = normalizeNumberOfDecimals(rawNumberOfDecimals);

    return admin;
  }

  mapModelToResponse(data: AdminDataInt, idKioks: string): AdminResponseInt {
    const values = [];

    for (const [key, value] of Object.entries(data)) {
      if (key !== 'maletas25KG' && key !== 'locales' && typeof value !== 'object') {
        values.push({ name: key, value: value });
      }
      if (key === 'LOCALES' || key === 'portPinpad') {
        values.push({ name: key, value: value.join('~') });
      }
    }

    return {
      maletas25KG: data.maletas25KG,
      id: idKioks,
      collection: values,
    };
  }
  determinateValue(value: string): string | boolean {
    let data: string | boolean = value;
    const compareData = value?.toLowerCase();
    if (['true', 'false'].includes(compareData)) {
      data = compareData === 'true';
    }
    return data;
  }
}
